<template>
  <div>
    <h2 class="el_h2">设备签回</h2>
    <el-form :inline="true" @submit.native.prevent>
      <el-form-item label="设备ID:">
        <el-input v-model="deviceID" @keyup.enter.native="device_change" placeholder="请使用扫码枪扫描温度计编码进行签收"></el-input>
      </el-form-item>
    </el-form>
    <div class="back_main">
      <div class="normal_back">
        <!-- 温度计签回区 -->
        <h2 class="el_h2">温度计签回区</h2>
        <el-table
        :data="real_device.slice((real_current_page-1)*real_page_size,real_current_page*real_page_size)"
        ref="real_device"
        highlight-current-row
        max-height="600"
        >
          <el-table-column align="center" type="index" label="NO"></el-table-column>
          <el-table-column
          align="center"
          width="200"
          prop="deviceId"
          show-overflow-tooltip
          label="实时温度计编号"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="info"
          show-overflow-tooltip
          label="信息"
          ></el-table-column>
        </el-table>
        <!-- 实时温度计分页 -->
        <el-pagination
        style="margin: 10px auto;"
        background
        @size-change="real_size_change"
        @current-change="real_current_change"
        :current-page="real_current_page"
        :page-sizes="[10,15,20,25]"
        :page-size="real_page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="real_device.length"
        ></el-pagination>
      </div>
      <div class="blue_back">
        <!-- 蓝牙温度计签回区 -->
        <h2 class="el_h2">蓝牙温度计签回区</h2>
        <el-table
        :data="blue_device.slice((blue_current_page-1)*blue_page_size,blue_current_page*blue_page_size)"
        ref="blue_device"
        highlight-current-row
        max-height="600"
        @row-click="blue_left_click"
        @row-dblclick="blue_row_click"
        @row-contextmenu="blue_right_click"
        >
          <el-table-column align="center" type="index" label="NO"></el-table-column>
          <el-table-column
          align="center"
          width="200"
          prop="deviceId"
          show-overflow-tooltip
          label="蓝牙温度计编号"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="status"
          label="信息"
          show-overflow-tooltip
          ></el-table-column>
        </el-table>
        <!-- 蓝牙温度计自定义菜单 -->
        <div id="menu">
          <ul>
            <li @click="delete_blue">
              <span>删除条目</span>
            </li>
          </ul>
        </div>
        <!-- 蓝牙温度计分页 -->
        <el-pagination
        style="margin: 10px auto;"
        background
        @size-change="blue_size_change"
        @current-change="blue_current_change"
        :current-page="blue_current_page"
        :page-sizes="[10,15,20,25]"
        :page-size="blue_page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="blue_device.length"
        ></el-pagination>
        <!-- 温度计音效 -->
        <!-- IE内核浏览器 -->
        <!-- <embed
        name="embedPlay"
        src="../../assets/msg_fail.mp3"
        :autostart="true"
        :loop="false"
        v-show="embed_hidden"
        ></embed> -->
        <!-- 非IE内核浏览器 -->
        <video
        id="audioPlay"
        v-show="audio_hidden"
        >
          <source src="../../assets/msg_fail.mp3" type="audio/mp3"></source>
        </video>
        <el-button
        icon="el-icon-s-promotion"
        type="primary"
        v-if="btn_permission.includes('middle:coldChain:signBackBluetooth')||btn_permission.includes('superAdmin')"
        @click="blue_confirm()">生成任务</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return{
        //权限数组
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        deviceID:'',
        device_id:'',
        // 实时温度计签回
        real_device:[],
        //实时温度计分页
        real_current_page:1,
        real_page_size:10,
        //蓝牙温度计签回
        blue_device:[],
        blue_current_page:1,
        blue_page_size:10,
        //温度计音效
        //IE内核
        // embed_hidden:true,
        //非IE内核
        audio_hidden:false,
        row_blue_now:[]
      }
    },
    created() {
      this.publicAjax.axios_set()
    },
    mounted() {

    },
    methods:{
      //生成签回任务
      device_change(){
        let that=this
        that.device_id=that.deviceID
        that.deviceID=''
        if(!that.device_id){
          return false
        }
        //判断是什么类型的温度计
        let isBlue=false
        let isReal=false
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/device/typeAndExpired/'+that.device_id,
        }).then(data=>{
          if(data.data.success==true){
            let data_list=data.data.data
            if(data_list.approve.indexOf('蓝牙温度计')!=-1){
              isBlue=true
              isReal=false
            }else if(data_list.approve.indexOf('实时温度计')!=-1||data_list.approve.indexOf('普通温度计')!=-1){
              isBlue=false
              isReal=true
            }
            if(data_list.approve.indexOf('到期')!=-1){
              that.$message.warning(data_list.approve)
            }
            if(data_list.approve==null){
              that.$message.warning(data_list.status)
            }
            if(isBlue){
              let f=true
              let n={
                'deviceId':that.device_id,
                'status':data_list.status
              }
              that.blue_device.map(item=>{
                if(item.deviceId==that.device_id){
                  f=false
                  return
                }
              })
              if(f){
                that.blue_device.push(n)
                //蓝牙温度计签回区双击事件
                that.blue_row_click(n)
                if(that.blue_device.length>10&&that.blue_device.length%that.blue_page_size==1){
                  //蓝牙温度计分页
                  that.blue_current_change(that.blue_current_page+1)
                }
              }
            }
            if(isReal){
              //实时温度计签回
              that.signBackByBatch(false,that.device_id)
            }
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //温度计音效
      playSound(){
        let browser=window.navigator.userAgent.toLowerCase()
        // if(browser.indexOf('ie')>=0){
        //   //IE内核浏览器
        //   this.embed_hidden=false
        //   let embed=document.embedPlay
        //   //浏览器不支持audio,则使用embed播放
        //   embed.volume=100
        // }else{

        // }
        //非IE内核浏览器
        // this.audio_hidden=true
        let audio=document.getElementById('audioPlay')
        //浏览器支持audio
        audio.play()
      },
      //温度计签回区
      //实时温度计分页
      real_size_change(val){
        this.real_page_size=val
      },
      real_current_change(val){
        this.real_current_page=val
      },
      //蓝牙温度计签回区
      //蓝牙温度计分页
      blue_size_change(val){
        this.blue_page_size=val
      },
      blue_current_change(val){
        this.blue_current_page=val
      },
      //蓝牙温度计生成任务
      blue_confirm(){
        let that=this
        if(!that.blue_device||!that.blue_device.length){
          return false
        }
        let putData=[]
        that.blue_device.map((item,index)=>{
          if(putData.indexOf(item.deviceId)==-1){
            putData.push(item.deviceId)
          }
        })
        that.signBackByBatch(true,putData)
      },
      //蓝牙温度计签回区鼠标左键点击事件
      blue_left_click(row,column,event){
        var menu=document.querySelector('#menu')
        menu.style.display='none'
      },
      //蓝牙温度计签回区双击事件
      blue_row_click(row,column,event){
        this.$refs.blue_device.setCurrentRow(row)
      },
      //蓝牙温度计签回区鼠标右键点击事件
      blue_right_click(row,column,event){
        this.row_blue_now=row
        var menu=document.querySelector('#menu')
        event.preventDefault()
        //根据事件对象中鼠标点击的位置，进行定位
        let menu_top=document.body.clientHeight-event.clientY
        if(menu_top<150){
          menu.style.top=event.clientY-20+'px'
        }else{
          menu.style.top=event.clientY+40+'px'
        }
        menu.style.left=event.clientX-200+'px'
        //改变自定义菜单的显示和隐藏
        menu.style.display='block'
        this.$refs['blue_device'].setCurrentRow(row)
      },
      //删除蓝牙温度计条目
      delete_blue(){
        var menu=document.querySelector('#menu')
        menu.style.display='none'
        this.blue_device.forEach((item,index)=>{
          if(item.deviceId==this.row_blue_now.deviceId){
            if(this.blue_device.length>10&&this.blue_device.length%this.blue_page_size==1){
              if(this.blue_current_page>1){
                //蓝牙温度计分页
                this.blue_current_change(this.blue_current_page-1)
              }
            }
            this.blue_device.splice(index,1)
          }
        })
      },
      //实时温度计或蓝牙温度计签回
      signBackByBatch(isBlue,postData){
        let that=this
        if(isBlue){
          const loading=this.$loading({
            lock:true,
            text:'正在签回，请稍候...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.3)'
          })
          that.$axios({
            method:'post',
            url:that.publicAjax.extra_path+'/middle/coldChain/signBackByBatch',
            data:JSON.stringify(postData),
            headers:{
              "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
              "content-type":"application/json;charset=UTF-8"
            }
          }).then(data=>{
            if(!data.data){
              that.playSound()
              loading.close()
              that.$message.warning('生成任务过程中异常，请联系管理员!')
              return false
            }
            if(!data.data.success){
              that.playSound()
              loading.close()
              that.blue_device.forEach((item,index)=>{
                if(data.data.message.indexOf(item.deviceId)!=-1){
                  that.$set(item,'status',data.data.message)
                }
              })
              that.$message({
                type:'warning',
                message:data.data.message,
                duration:0,
                showClose:true
              })
              return false
            }
            loading.close()
            that.$message.success('任务组已生成!')
            that.blue_device=[]
          })
        }else{
          let n={'deviceId':that.device_id,'signed':0,info:''}
          let ans=0
          that.$axios({
            method:'post',
            url:that.publicAjax.extra_path+'/middle/coldChain/signBack/'+postData,
            headers:{
              "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
              "content-type":"application/json;charset=UTF-8"
            }
          }).then(data=>{
            if(data.data.success==true){
              that.$message.success(data.data.message)
              let qrRs=data.data.data

            }else{
              that.playSound()
              that.$message.warning(data.data.message)
            }
            if(!data.data){
              that.playSound()
              that.$message.warning('执行异常')
            }
            if(!data.data.data){
              n.info=data.data.message
            }else if(data.data.success){
              n={'deviceId':that.device_id,'signed':1,info:data.data.message}
              ans=1
            }else{
              n.info=data.data.data
            }
            let f=true
            if(!that.real_device||!that.real_device.length){
              that.real_device.push(n)
            }
            that.real_device.map(item=>{
              if(item.deviceId==that.device_id){
                if(item.signed!=1){
                  item.signed=ans
                  item.info=data.data.data
                  if(!data.data.data||data.data.success){
                    item.info=data.data.message
                  }
                  f=false
                  return false
                }else{
                  f=false
                  return false
                }
              }
            })
            if(f){
              that.real_device.push(n)
            }
          })
        }
      }
    }
  }
</script>

<style scoped="scoped">
  .back_main{
    display: flex;
    justify-content: space-between;
  }
  .normal_back{
    width: 45%;
  }
  .blue_back{
    width: 45%;
  }
  .el_h2{
    border-left: 4px solid #409EFF;
    padding: 10px;
    margin: 10px 0;
    font-size: 16px;
    background: #F5F7FA;
  }
  .el-form-item{
    margin-bottom: 0px;
  }
  /* 右键菜单 */
  #menu{
    position: absolute;
    display: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    background: #FFFFFF;
    cursor: pointer;
    color: #606266;
    width: 200px;
    border: 1px solid #e4e7ed;
    font-size: 14px;
    z-index: 999;
  }
  #menu ul{
    list-style: none;
    margin: 0px;
    padding: 0px;
  }
  #menu ul li{
    padding: 0px 10px;
    height: 30px;
    line-height: 30px;
    position: relative;
    box-sizing: border-box;
    text-indent: 8px;
  }
  #menu ul li:hover{
    background-color: #ecf5ff;
  }
</style>



// WEBPACK FOOTER //
// src/components/cold/back.vue